module.exports = __webpack_public_path__ + "img/deal-view-point-banner.9c2e1971.png";